export const ThirdPartyTaxAdvisorUrls = {
  MY_CLIENTS: "/third-party-tax-advisor/clients"
};
